import { SectionLabel } from '../common/SectionLabel';

const LayoutStatisticsCalendar = ({
  children,
  noLabel = false,
}: {
  children: React.ReactNode;
  noLabel?: boolean;
}) => {
  return (
    <article className="flex flex-col gap-[12px]">
      <div className="flex items-center justify-between">
        {!noLabel && <SectionLabel title="이번달 매출" className="" />}

        <div className="flex gap-[16px]">
          <LegendDotLabel label="매출" colorClass="bg-point-500" />
          <LegendDotLabel label="정산" colorClass="bg-gr-500" />
        </div>
      </div>
      <article className="">{children}</article>
    </article>
  );
};

export default LayoutStatisticsCalendar;

interface LegendDotLabelProps {
  colorClass: string;
  label: string;
}

const LegendDotLabel = ({ colorClass, label }: LegendDotLabelProps) => {
  return (
    <div className="flex items-center gap-[7px] text-gr-700 Body5M14">
      <div className={`h-[8px] w-[8px] rounded-full ${colorClass}`} />
      <span>{label}</span>
    </div>
  );
};
